import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltIconDownloadOutline } from '@cae/cobalt-react/icons/outline/CobaltIconDownloadOutline';
import { useDownloadCreditMemo } from '@features/invoices/hooks/use-download-credit-memo/useDownloadCreditMemo';
import { FEATURE_FLAGS } from '@shared/constants/featureFlags.constants';
import { useFlags } from 'launchdarkly-react-client-sdk';
import * as React from 'react';

import type { CreditMemoDownloadCellProps } from './CreditMemoDownloadCell.types';

import styles from './CreditMemoDownloadCell.module.css';
const CreditMemoDownloadCell = React.memo(
  ({
    creditMemoId,
    creditMemoNumber,
  }: Readonly<CreditMemoDownloadCellProps>): React.ReactElement | null => {
    const flags = useFlags();
    const { handleDownload, isDownloading } = useDownloadCreditMemo({
      creditMemoId,
      creditMemoNumber,
    });

    const handleClick = React.useCallback(
      (event: React.MouseEvent): void => {
        event.stopPropagation();
        void handleDownload();
      },
      [handleDownload]
    );

    if (flags[FEATURE_FLAGS.displayCreditMemoDownload] !== true) {
      return null;
    }

    return (
      <CobaltButton
        variant="ghost"
        pending={isDownloading}
        onClick={handleClick}
        aria-label={`Download credit memo ${creditMemoNumber}`}
        data-testid="credit-memo-download-button"
        className={styles.downloadButton}
      >
        <CobaltIconDownloadOutline size="small" aria-hidden="true" />
      </CobaltButton>
    );
  }
);

CreditMemoDownloadCell.displayName = 'CreditMemoDownloadCell';
export { CreditMemoDownloadCell };
